export default __webpack_public_path__ + "static/media/replay_active.f6c3a5dc.svg";